export default __webpack_public_path__ + "static/media/OpdClaim.a1e7209b.svg";